import * as React  from "react";
import {cs}        from "@Common/react/chain-services";

export const genBuscard = ({session, specificationFields, specFieldOnChange, next}) => cs(
    ["specFieldDuplicates", ({}, next) => next([])],
    ["ordinalPosition", ({}, next) => next(2)],

    (({ specFieldDuplicates, ordinalPosition }, next) => {
        let count = 0;
    
        specificationFields.forEach(field => {
            count++;
            //mapping fields as per BOOT_gen_buscard_spec.inc (build2)
            // If no current value in field (default data, reorder, pending order), map default data specific to buildPath to fields
            if (!field.data) {
                const label = field.displayLabel?.toLowerCase();
    
                if (label === 'email') {
                    field.data = session.data.agent?.agentEmail;
                    count = count - 1; // adjust count like in PHP BOOT_gen_buscard_spec.inc
                } else {
                    field.data = session.data.agent?.[`agentDisplay${count}`];
                }
            }
    
            // Assign ordinal and push to duplicates array
            field.ordinal = ordinalPosition;
            specFieldDuplicates.push(field);
            ordinalPosition++;
        });
    
        next();
    }),    
    (({specFieldDuplicates}, next) => next(specFieldOnChange(specFieldDuplicates))),
    ({specFieldDuplicates}) => next(specFieldDuplicates)
);